import { styled } from '@mui/system';
import {
  SectionHeading,
  SectionSubtext,
  DisclaimerText,
  CtaWrapper,
} from '../../styles';
import { CTAButton as BaseCTAButton } from '../../../../../components/Header/styles';

export const HypnotherapyHeading = styled(SectionHeading)(({ theme }) => ({
  marginBottom: '14px',
  letterSpacing: '.5px',
  [theme.breakpoints.down('md')]: {
    marginBottom: '12px',
  },
  [theme.breakpoints.down('sm')]: {
    marginBottom: '10px',
  },
}));

export const HypnotherapyIntroText = styled(SectionSubtext)(({ theme }) => ({
  marginTop: '14px',
  marginBottom: '14px',
  fontWeight: 400,
  [theme.breakpoints.down('md')]: {
    fontSize: '16px',
  },
}));

export const HypnotherapySecondText = styled(SectionSubtext)(({ theme }) => ({
  marginBottom: '48px',
  [theme.breakpoints.down('md')]: {
    marginBottom: '36px',
    fontSize: '18px',
  },
  [theme.breakpoints.down('sm')]: {
    marginBottom: '24px',
    fontSize: '16px',
  },
}));

export const HypnotherapyDisclaimerText = styled(DisclaimerText)(({ theme }) => ({
  marginBottom: '82px',
  fontSize: '22px',
  [theme.breakpoints.down('md')]: {
    fontSize: '12px',
  },
}));

export const HypnotherapyCtaWrapper = styled(CtaWrapper)(({ theme }) => ({
  [theme.breakpoints.down('md')]: {
    marginTop: '40px',
  },
  [theme.breakpoints.down('sm')]: {
    marginTop: '30px',
  },
}));

export const HypnotherapyCTAButton = styled(BaseCTAButton)(({ theme }) => ({
  padding: '20px 50px',
  margin: 0,
  minWidth: '297px',
  [theme.breakpoints.down('md')]: {
    padding: '16px 40px',
    minWidth: '260px',
    fontSize: '18px',
  },
  [theme.breakpoints.down('sm')]: {
    padding: '14px 30px',
    minWidth: '220px',
    fontSize: '16px',
    width: '100%',
    maxWidth: '297px',
  },
}));
